<template>
  <div>
    <form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-2">
          <label for="fromDate">From Date</label>
          <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="toDate">To Date</label>
          <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
        </div>
        <div class="p-field p-col-12 p-md-1 p-mt-5">
          <Button @click.prevent="searchReport" class="p-button-raised" label="Search" icon="pi pi-search" />
        </div>
      </div>
    </form>
    <div class="p-fluid p-grid">
      <div class="p-col-12 p-md-6">
        <canvas id="user-wise-bar"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="user-wise-line"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import DatePicker from 'vue2-datepicker'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import $ from 'jquery'

export default {
  name: 'UserWiseChart',
  components: {
    DatePicker,
    InputMask,
    Button
  },
  data() {
    return {
      fromDate: null,
      toDate: null,
      userWiseBarChart: null,
      userWiseLineChart: null,
      englishDateEnabled: true
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.initializeDates()
  },
  methods: {
    async searchReport() {
      const data = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      try {
        const resp = await this.$store.dispatch('loadUserWiseSalesCountGraph', data)
        this.createUserWiseChart(resp)
      } catch (error) {
        console.error('Error fetching user-wise sales data:', error)
      }
    },
    createUserWiseChart(data) {
      const labels = data.labels
      const salesCountData = data.datasets.find(d => d.label === 'Sales Count').data
      const totalSalesData = data.datasets.find(d => d.label === 'Total Sales').data
      const ctxBar = document.getElementById('user-wise-bar')
      if (this.userWiseBarChart) {
        this.userWiseBarChart.destroy()
      }
      const barChartData = {
        labels: labels,
        datasets: [{
          label: 'Total Sales',
          backgroundColor: '#42b3f4',
          data: totalSalesData
        }]
      }
      const barOptions = {
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              const index = tooltipItem.index
              const salesCount = salesCountData[index]
              const totalSales = totalSalesData[index]
              return [`Sales Count: ${salesCount}`, `Total Sales: ${totalSales}`]
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
      this.userWiseBarChart = new Chart(ctxBar, {
        type: 'bar',
        data: barChartData,
        options: barOptions
      })
      const ctxLine = document.getElementById('user-wise-line')
      if (this.userWiseLineChart) {
        this.userWiseLineChart.destroy()
      }
      const lineChartData = {
        labels: labels,
        datasets: [{
          label: 'Sales Count',
          borderColor: '#f44141',
          fill: false,
          data: salesCountData
        }]
      }
      const lineOptions = {
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              const index = tooltipItem.index
              const salesCount = salesCountData[index]
              const totalSales = totalSalesData[index]
              return [`Sales Count: ${salesCount}`, `Total Sales: ${totalSales}`]
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
      this.userWiseLineChart = new Chart(ctxLine, {
        type: 'line',
        data: lineChartData,
        options: lineOptions
      })
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    initializeDates() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
    },
    setEnglishDate() {
      const today = new Date()
      this.fromDate = today.toISOString().slice(0, 10)
      this.toDate = today.toISOString().slice(0, 10)
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// UserWiseSalesCounntGraph.vue?5aa1c362